import policies from './widgetPermissions.json';

export function canAccessWidget(widgetId, user) {
  if ((policies[widgetId]?.visibility || 'public') === 'public') return true;
  return Boolean(user && user.is_active !== false && (
    user.role === 'admin' || user.allowed_private_widgets?.includes(widgetId)
  ));
}

export function publicWidgetStates(states = {}) {
  return Object.fromEntries(Object.entries(states).filter(([id]) =>
    (policies[id]?.visibility || 'public') === 'public'));
}
